var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2403_4524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.322 24.6257C14.1454 24.8023 13.9295 24.8906 13.6744 24.8906C13.4193 24.8906 13.2035 24.8023 13.0269 24.6257L3.84369 15.7663C3.74557 15.6878 3.61067 15.5602 3.43898 15.3836C3.26728 15.207 2.99502 14.8857 2.6222 14.4197C2.24938 13.9537 1.9158 13.4754 1.62147 12.9848C1.32713 12.4943 1.06468 11.9007 0.834123 11.2041C0.603562 10.5075 0.488281 9.83055 0.488281 9.17321C0.488281 7.01476 1.11129 5.32725 2.3573 4.11067C3.60331 2.89409 5.32517 2.2858 7.52286 2.2858C8.13115 2.2858 8.7517 2.39127 9.38452 2.60221C10.0173 2.81314 10.606 3.09767 11.1505 3.45577C11.695 3.81388 12.1635 4.14991 12.556 4.46387C12.9484 4.77782 13.3212 5.1114 13.6744 5.4646C14.0276 5.1114 14.4005 4.77782 14.7929 4.46387C15.1853 4.14991 15.6538 3.81388 16.1983 3.45577C16.7429 3.09767 17.3315 2.81314 17.9643 2.60221C18.5972 2.39127 19.2177 2.2858 19.826 2.2858C22.0237 2.2858 23.7455 2.89409 24.9916 4.11067C26.2376 5.32725 26.8606 7.01476 26.8606 9.17321C26.8606 11.3415 25.7372 13.549 23.4905 15.7957L14.322 24.6257Z",
    fill: "#333333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2403_4524"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.3963,
    height: 26.3723,
    fill: "white",
    transform: "matrix(1 0 0 -1 0.476562 26.7734)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/Heart.1f40209abcb467330a0678811409c2ff.svg";
export { ForwardRef as ReactComponent };